import React from 'react';
import { FadeIn } from './FadeIn';
export function DiagnosisSection() {
  return <section className="py-24 px-6 bg-navy-dark" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <FadeIn data-id="element-53">
          <h2 className="text-3xl md:text-5xl font-serif mb-10 text-center md:text-left" data-id="element-54">
            El problema no es la carga… <br className="hidden md:block" data-id="element-55" />
            <span className="text-gold" data-id="element-56">
              es cómo está construido tu negocio
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg md:text-xl text-gray-light font-sans mb-12" data-id="element-57">
          <FadeIn delay={0.1} data-id="element-58">
            <p data-id="element-59">
              Probablemente piensas que el problema es que tienes demasiado
              trabajo o que necesitas un mejor equipo. Pero eso es solo la
              superficie.
            </p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-60">
            <p data-id="element-61">
              El problema real es que tu negocio ha crecido sin una estructura
              operativa clara que lo sostenga.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-62">
          <div className="mb-16" data-id="element-63">
            <h3 className="text-xl font-semibold text-white mb-6" data-id="element-64">
              Cuando no hay estructura:
            </h3>
            <ul className="space-y-4" data-id="element-65">
              {['los procesos no están definidos o no se cumplen', 'las decisiones dependen de demasiadas personas (o de ti)', 'el equipo ejecuta, pero sin suficiente claridad', 'la operación se vuelve reactiva'].map((item, i) => <li key={i} className="flex items-center gap-4 text-lg text-gray-light" data-id="element-66">
                  <span className="w-6 h-[2px] bg-gold shrink-0" data-id="element-67"></span>
                  {item}
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-68">
          <div className="bg-white/[0.03] border border-white/10 p-8 md:p-12 rounded-xl text-center" data-id="element-69">
            <p className="text-2xl md:text-4xl font-serif text-gold leading-tight" data-id="element-70">
              No es un problema de trabajar más.{' '}
              <br className="hidden md:block" data-id="element-71" />
              Es un problema de diseño.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}